import React, { useContext, useEffect } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import { getDataRoomRoute } from 'utils';
import DocumentsGlobalSecurity from 'router/subrouters/DataRoom/subrouters/Settings/pages/SetupPage/components/DocumentsGlobalSecurity';
import OnboardingContext from 'router/subrouters/DataRoom/providers/Onboarding/Onboarding.context';
import mixpanelService from 'services/mixpanelService';
import useGetMixpanelProps from 'hooks/useGetMixpanelProps';
import { FileSecurityVisitedEventProps } from 'models/MixpanelEvents';

import './FileSecurityPage.styles.scss';

type FileSecurityPageProps = {
  className?: string;
};

const FileSecurityPage: React.FC<FileSecurityPageProps> = (props) => {
  const { className } = props;

  const {
    isAdmin,
    dataRoom: { _id, name },
  } = useContext(DataRoomContext);

  const { contentCard } = useContext(OnboardingContext);

  const classes = classNames('file-security-page', 'page', className);

  const { t } = useTranslation();

  const getMixpanelProps = useGetMixpanelProps();

  useEffect(() => {
    if (!isAdmin) return;

    mixpanelService.fileSecurityVisited(
      getMixpanelProps({
        dataRoomId: _id,
        dataRoomName: name,
      }) as FileSecurityVisitedEventProps,
    );
  }, [_id, name, isAdmin, getMixpanelProps]);

  if (!isAdmin)
    return <Navigate to={getDataRoomRoute(_id, 'documents')} replace />;

  return (
    <div className={classes}>
      <h2>{t('fileSecurity')}</h2>

      {contentCard}

      <DocumentsGlobalSecurity />
    </div>
  );
};

export default FileSecurityPage;
